import React from "react";
import { FooterOrange } from "../../common/FooterOrange/FooterOrange";
import { EraningCreditSteps } from "./components/EraningCreditSteps";
import { TransactionCredit } from "./components/TransactionCredit";
import { WhyMobinCredit } from "./components/WhyMobinCredit";
// import styles from "./style.module.css";


export const Credit = () => {
  return (
    <>
      <TransactionCredit />
      <WhyMobinCredit />
      {/*<EraningCreditSteps />*/}
      <FooterOrange
        text={" مهمترین ویژگی اعتبار مبین سرمایه، تیم حرفه‌ای ما است. همکاران ما در واحد اعتبارات مبین سرمایه همواره در تلاشند تا بهترین شرایط معاملات اعتباری را برای شما ایجاد کنند."}
        btn={"#ff5f00"}
        color={"white"}
        href={"https://reg.mobinsb.ir/Common/account/login?ReturnUrl=%2F"}
      />
    </>
  );
};
